module.exports = __webpack_public_path__ + "img/canvaBorderBottom.7976bfd0.svg";